import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f109bce")

_pushScopeId("data-v-3f109bce")
const _hoisted_1 = {
  class: "form-year-picker relative",
  style: {"width":"fit-content"},
  ref: "calendarYear"
}
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "flex justify-between items-center text-grey-333" }
const _hoisted_4 = { class: "mt-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Input = _resolveComponent("Input")
  const _directive_click_outside = _resolveDirective("click-outside")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.isShowChevron)
        ? (_openBlock(), _createBlock("span", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleBackYear && _ctx.handleBackYear(...args))),
            class: "cp-icon-chevron-left text-2xl cursor-pointer mr-2"
          }))
        : _createCommentVNode("", true),
      _createVNode("div", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
        style: { width: _ctx.width + 'px' }
      }, [
        _createVNode(_component_Input, {
          disabled: _ctx.disabled,
          placeholder: _ctx.placeholder,
          modelValue: _ctx.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.value = $event)),
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeInput($event))),
          iconPrepend: "cp-icon-calendar"
        }, null, 8, ["disabled", "placeholder", "modelValue"])
      ], 4),
      (_ctx.isShowChevron)
        ? (_openBlock(), _createBlock("span", {
            key: 1,
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleNextYear && _ctx.handleNextYear(...args))),
            class: "cp-icon-chevron-right text-2xl cursor-pointer ml-2"
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", {
      class: ["datepicker--calendar-year", !_ctx.isShowCalendar ? 'hidden' : ''],
      ref: "popupCalendar"
    }, [
      _createVNode("header", _hoisted_3, [
        _createVNode("span", {
          class: "cp-icon-chevron-left cursor-pointer text-2xl",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.prevYear && _ctx.prevYear(...args)))
        }),
        _createVNode("span", null, _toDisplayString(_ctx.startYear) + " - " + _toDisplayString(_ctx.startYear + 9), 1),
        _createVNode("span", {
          class: "cp-icon-chevron-right cursor-pointer text-2xl",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextYear && _ctx.nextYear(...args)))
        })
      ]),
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array.from(Array(10).keys()), (item) => {
          return (_openBlock(), _createBlock("span", {
            onClick: ($event: any) => (_ctx.onSelectYear(_ctx.startYear + item)),
            class: ["cell year", [
            _ctx.startYear + item === Number(_ctx.value) ? 'selected' : '',
            _ctx.startYear + item === _ctx.year ? 'year-current' : '',
          ]],
            key: item
          }, _toDisplayString(_ctx.startYear + item), 11, ["onClick"]))
        }), 128))
      ])
    ], 2)
  ], 512)), [
    [_directive_click_outside, _ctx.closeCalendar]
  ])
})